export const DATA_ERROR_MESSAGE = `משהו לא מסתדר לנו בנתונים שהזנת\nניתן לנסות שוב או ליצור איתנו קשר`

export const NO_MORT_QUE_FILLED = `היי, נראה שעדיין לא הגשת בקשה\nלמשכנתא אצלנו :)`

export const FOREIGN_RESIDENT_TEXT = `לקבלת פרטים אודות ההלוואה שלך ניתן\nליצור קשר עם נציגי השירות שלנו`
export const NO_ACTIVE_LOANS_TEXT = `היי, נראה שעדיין לא קיימת לך הלוואה פעילה\nאצלנו, לאיזור האישי ניתן להכנס רק לאחר\nביצוע ההלוואה.`

export const FOREIGN_RESIDENT_TITLE = `תושב חוץ?`

export const NO_ACTIVE_LOANS_CTA = `לכל שאלה על הלוואה שנמצאת בתהליך ניתן לפנות לשירות\nהלקוחות`